function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteBurgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 214",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Burger Menu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("line", {
    y1: 107,
    x2: 256,
    y2: 107,
    style: {
      fill: "none",
      stroke: "#FFF",
      strokeMiterlimit: 10,
      strokeWidth: 20
    }
  }), /*#__PURE__*/React.createElement("line", {
    y1: 204,
    x2: 256,
    y2: 204,
    style: {
      fill: "none",
      stroke: "#FFF",
      strokeMiterlimit: 10,
      strokeWidth: 20
    }
  }), /*#__PURE__*/React.createElement("line", {
    y1: 10,
    x2: 256,
    y2: 10,
    style: {
      fill: "none",
      stroke: "#FFF",
      strokeMiterlimit: 10,
      strokeWidth: 20
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteBurgerMenu);
export default __webpack_public_path__ + "static/media/white_burger_menu.1082e3e8b5f83aba1fdd9d292972b428.svg";
export { ForwardRef as ReactComponent };